// extracted by css-extract-rspack-plugin
export default {"title":"_81932df7","itemStatus":"_71fc8856","statusContainer":"_35eece4","iconContainer":"_910784bb","icon":"_653dfe1c"};